import { Coordinates } from '../contracts'

export const toLngLat = (latLng: Coordinates): Coordinates => [latLng[1], latLng[0]]
export const toLatLng = toLngLat
